import { UserListRequest } from "@/api/models/user/UserListRequest";
import { CancelablePromise, OpenAPI, type Response } from "@/api";
import { UserListResponse } from "@/api/models/user/UserListResponse";
import { request as __request } from "@/api/core/request";
import { UserUpdateRequest } from "@/api/models/user/UserUpdateRequest";
import { ToDeleteRequest } from "@/utils/slice";

export class UserService {
  public static ListAll(
    body: UserListRequest
  ): CancelablePromise<UserListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/user",
      body: body,
    });
  }

  public static Update(body: UserUpdateRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/user",
      body: body,
    });
  }

  public static UpdateBalance(
    body: UserUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/user",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/user",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/user/drop",
      body: ToDeleteRequest(body),
    });
  }
}
